<template>
  <div style="margin: -18px -20px">
    <iframe
      id="map"
      :src="mapUrl"
      width="100%"
      height="calc(100vh - 60px)"
      frameborder="0"
    >
    </iframe>
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    <coming-soon-modal />
  </div>
</template>

<script>
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

export default {
  name: "AviationMap",
  components: { ComingSoonModal },
  data() {
    return {
      // mapUrl: 'https://proxy.aivector.com/proxy/?ll=41.5109919636419,-104.8385660384&chart=11&zoom=3',
      // mapUrl: 'https://192.168.2.77:3750/proxy/?ll=41.5109919636419,-104.8385660384&chart=11&zoom=3',
      mapUrl:
        "https://vfrmap.com/?type=vfrc&lat=33.308&lon=-111.655&zoom=10&api_key=763xxE1MJHyhr48DlAP2qQ",
      errorMessage: "",
    };
  },
};
</script>

<style scoped>
#map {
  height: calc(100vh - 60px);
  width: 100%;
  z-index: 0;
}

.error-message {
  color: red;
  margin: 20px;
}
</style>
